import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { AddMfaBackup, LoginOAuthParams } from '../models';
import { CancelMethodPairingService } from '../services/multi-factor-authentication-adapter-service/cancel-method-pairing/cancel-method-pairing.service';
import { MfaUtilService } from '../services/multi-factor-authentication-adapter-service/util-service/mfa-util.service';
import { FlyDeltaMethodService } from '../services/multi-factor-authentication-wrapper-service/fly-delta-method/fly-delta-method.service';

@Injectable({
  providedIn: 'root'
})
export class MultiFactorAuthenticationUtilsService {
  flowId = '';

  constructor(
    private cancelPairing: CancelMethodPairingService,
    private flyDeltaMethod: FlyDeltaMethodService,
    private mfaUtils: MfaUtilService
  ) {}

  cancelMethodPairing(
    loginOAuthParams: LoginOAuthParams
  ): Observable<AddMfaBackup | string> {
    return this.cancelPairing
      .cancelMethodPairing(
        loginOAuthParams.oauthConfig,
        this.flowId ? this.flowId : ''
      )
      .pipe(
        tap(() => {
          this.flyDeltaMethod.cancelPairing$.next();
        }),
        catchError((error) => {
          return of(this.mfaUtils.getMfaRegistrationError(error));
        })
      );
  }
}
